<div class="breadcrumb-bar">
  <div class="breadcrumb">
    <span class="breadcrumb-link">Help</span>
    <span class="breadcrumb-sep"></span>
    <span class="breadcrumb-current">Frequently Asked Questions</span>
  </div>
</div>

<main class="page-content">
  <div class="page-grid">
    <section class="card page-header-card">
      <h1 class="page-title">Frequently Asked Questions</h1>
      <p class="page-copy">Answers to common questions about using AST, grouped by topic.</p>
    </section>

    <section class="card category-jump">
      <span class="category-jump-label">Jump to a category</span>
      <div class="category-jump-links">
        <ng-container *ngFor="let category of helpFaqList">
          <span class="category-jump-break" *ngIf="category.key === 'rolesAndAccess'"></span>
          <button
            type="button"
            class="category-jump-btn"
            (click)="scrollToCategory(category.key)"
          >
            {{ category.labelName }}
          </button>
        </ng-container>
      </div>
    </section>

    <section class="card faq-categories-card">
      <div class="faq-category" *ngFor="let category of helpFaqList" [id]="category.key">
        <button type="button" class="faq-category-header" (click)="toggleCategory(category.key)">
          <svg class="faq-category-caret" [class.faq-category-caret--collapsed]="!isCategoryExpanded(category.key)" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
          <h2 class="faq-category-label">{{ category.labelName }}</h2>
          <span class="faq-category-count">{{ category.questionCount }} Questions</span>
        </button>

        <ng-container *ngIf="isCategoryExpanded(category.key)">
          <div class="faq-question" *ngFor="let qa of category.questionAnswerList; let i = index">
            <button
              type="button"
              class="faq-question-header"
              [class.faq-question-header--open]="isQuestionExpanded(category.key, i)"
              (click)="toggleQuestion(category.key, i)"
            >
              <span>{{ qa.question }}</span>
              <svg class="faq-toggle-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
            <p class="faq-answer" *ngIf="isQuestionExpanded(category.key, i)">{{ qa.answer }}</p>
          </div>
        </ng-container>
      </div>
    </section>
  </div>
</main>
